module.exports = __webpack_public_path__ + "static/pattern-88c9633465ba3cb1c5bfe2242dc37d67.png";